import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { OktaAuth, TokenResponse, Tokens } from '@okta/okta-auth-js';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

interface IberoSearchResponse {
  // Define your response interface here
  data: any;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class OktaAuthService {
  private oktaAuth: OktaAuth;
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
    this.oktaAuth = new OktaAuth({
      clientId: '0oanytwg4yEYRIa0S417',
      issuer: 'https://psoplaneta.okta.com',
      redirectUri: window.location.origin,
      scopes: ['openid', 'profile', 'email'],
      pkce: true
    });
  }

  async login() {
    try {
      await this.oktaAuth.signInWithRedirect();
    } catch (error) {
      console.error('Error during login:', error);
      throw error;
    }
  }

  async handleAuthentication() {
    try {
      const tokenResponse = await this.oktaAuth.token.parseFromUrl();
      const { tokens } = tokenResponse;
      
      if (tokens) {
        Object.keys(tokens).forEach(key => {
          const token = tokens[key as keyof Tokens];
          if (token) {
            this.oktaAuth.tokenManager.add(key, token);
          }
        });
      }
      
      return tokens;
    } catch (error) {
      console.error('Error handling authentication:', error);
      throw error;
    }
  }

  async logout() {
    try {
      await this.oktaAuth.signOut();
    } catch (error) {
      console.error('Error during logout:', error);
      throw error;
    }
  }

  async isAuthenticated(): Promise<boolean> {
    return await this.oktaAuth.isAuthenticated();
  }

  getAccessToken(): string | undefined {
    return this.oktaAuth.getAccessToken();
  }

  searchEmailInIbero(username: string, accessToken: string): Observable<IberoSearchResponse> {
    if (!username || !accessToken) {
      return throwError(() => new Error('Los datos de respuesta de Azure son incompletos o inválidos. Se requiere account.username y accessToken.'));
    }

    const endpoint = `${this.apiUrl}/ibero/search-email`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    
    const requestBody = {
      azure_email: username,
      azure_token: accessToken,
    };

    return this.http.post<IberoSearchResponse>(endpoint, requestBody, { headers })
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Ocurrió un error en la operación';

    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.error?.message || error.message}`;
    }

    console.error('Hubo un problema con la operación de búsqueda de email:', errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}